import React from 'react'
import {
  ButtonComponent,
  InputComponent,
  SelectComponent
} from '@shopeasy-dashboard-ui/ui-library';
import { Transition } from './Transition'
import { QuestionCircleFill, X } from 'react-bootstrap-icons'
import { Dialog, Tooltip } from '@mui/material'
import { t } from 'i18next'
import { BardSvg } from '../Assets/StaticData/BardSvg'

const ImageGeneratePrompt = ({
    imageGenerateAiPopup,
    setImageGenareteAiPopup,
    imageGenerateAiData,
    imageWarn,
    setImageWarn,
    handleChangeImageAiData,
    handleSubmitAiImage
}) => {
    return (
        <Dialog
            open={imageGenerateAiPopup}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => setImageGenareteAiPopup(false)}
            aria-describedby='alert-dialog-image-generate-prompt'
            style={{ zIndex: 9999999 }}
            sx={{ zIndex: 9999999 }}
        >
            <div className='w-[350px] md:w-[600px] max-h-full'>
                <div className='relative secondary-bg-color shadow dark:bg-gray-700 p-5'>
                    <div className='flex items-center justify-between border-b main-border-color mb-3 pb-3 rounded-t dark:border-gray-600'>
                        <h6 className='capitalize font-medium  text-primary flex items-center justify-center gap-2'>
                            <BardSvg /> {t('lang_generate_image')}
                        </h6>
                        <button
                            type='button'
                            className='close-btn'
                            onClick={() => {
                                setImageGenareteAiPopup(false);
                            }}
                        >
                            <X className='h-4 w-4' aria-hidden='true' />
                        </button>
                    </div>
                    <form onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()} onSubmit={handleSubmitAiImage}>
                        <div className='mb-4'>
                            <label className='flex' htmlFor='Prompt'>
                                {t('lang_prompt')}
                                <span className='text-red-500 ms-1'>*</span>
                                <Tooltip
                                    title='Write prompt for image generation'
                                    arrow
                                    placement='right'
                                    className='ml-2 -tracking-tighter'
                                >
                                    <QuestionCircleFill className='info-link cursor-pointer' />
                                </Tooltip>
                            </label>
                            <InputComponent
                                className={
                                    imageWarn
                                        ? `border-red-500`
                                        : ``
                                }
                                type='text'
                                name='prompt'
                                value={imageGenerateAiData?.prompt}
                                onChange={handleChangeImageAiData}
                                onBlur={(e) => {
                                    if (imageGenerateAiData?.prompt?.length <= 0) {
                                        setImageWarn(true)
                                    } else {
                                        setImageWarn(false)
                                    }
                                }}
                                placeholder='e.g. Blog about your latest products or deals'
                            />
                        </div>
                        <div className='mb-4'>
                            <label>{t('lang_Product_Type')}</label>
                            <div className='relative'>
                                <SelectComponent
                                    name='size'
                                    placeholder='Select product type'
                                    value={imageGenerateAiData?.size}
                                    onChange={handleChangeImageAiData}
                                    options={[
                                        { value: '1024x1024', label: '1024x1024' },
                                        { value: '1024x1792', label: '1024x1792' },
                                        { value: '1792x1024', label: '1792x1024' },
                                    ]}
                                    required
                                />
                            </div>
                        </div>
                        <div className='flex justify-between'>
                            <ButtonComponent type='submit' disabled={imageWarn} variant='primary'>
                                {t('lang_generate')}
                            </ButtonComponent>
                        </div>
                    </form>
                </div>
            </div>
        </Dialog>
    )
}

export default ImageGeneratePrompt